import React, {FC, useMemo} from 'react';
import Box from '@material-ui/core/Box';

import ActivationItemWrapper from './ActivationItemWrapper';
import ActivationsItem from './ActivationsItem';
import {getRank} from '../../../../../sidebar/Utils';
import {ActivationData, DateRange} from '../../../../../../types';
import useStyles from './ActivationList.styles';
import {getColorIndex} from '../../utils';

export interface ActivationsListProps extends DateRange {
    activations: ActivationData[];
    activeIndex: number;
    handleIndexChange: (index?: number) => void;
}

export interface ActivationsItemProps extends ActivationData {
    rank: number;
}

const ActivationsList: FC<ActivationsListProps> = ({
    activations,
    startDate,
    endDate,
    ...props
}: ActivationsListProps) => {
    const maxValue = activations && activations.length && activations[0].activations;
    const styles = useStyles();

    const activationsWithBar: ActivationsItemProps[] = useMemo(() => {
        return (
            (activations &&
                activations.length &&
                activations.map(list => ({
                    ...list,
                    rank: getRank(maxValue as number, list.activations as number)
                }))) ||
            []
        );
    }, [activations]);

    return (
        <Box className={styles.activationsList}>
            {activationsWithBar.map((activationsWithBar, index) => (
                <ActivationItemWrapper key={index} index={index} {...props}>
                    <ActivationsItem
                        key={index}
                        {...activationsWithBar}
                        colorIndex={getColorIndex(index)}
                        startDate={startDate}
                        endDate={endDate}
                    />
                </ActivationItemWrapper>
            ))}
        </Box>
    );
};

export default ActivationsList;
